// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails

// This is a list of feature flags that are overwritable by products. The defaults are still loaded from the client
export const PRODUCT_FEATURE_FLAGS = {};

export const DEFAULT_FEATURE_FLAGS = {
	'ptc-directory-ui.enable.cancel-join-requests-silently': false,
	'ptc-directory-ui.deny-open-sites-in-fe': false,
	'ptc-directory-ui.enable.atlas-team-health-monitor': false,
	...PRODUCT_FEATURE_FLAGS,
};
